import {css} from 'lit'; export default css`.hotkey-section{margin:0 189px var(--goto-spacing-08) var(--goto-spacing-07)}.hotkey-section-list{list-style:none;padding:0}.hotkey-section-list li{margin:12px 0}`;
    